import { setCurrentAnnotationId } from "@/store/ai-asset-review/ai-asset-review-slice";
import { changeMode } from "@/store/mode-slice";
import { Mode } from "../mode";
import { AiAssetReviewOverlay } from "./ai-asset-review-overlay";

export const aiAssetReviewMode: Mode = {
  name: "aiAssetReview",
  ModeScene: () => null,
  ModeOverlay: AiAssetReviewOverlay,
  hasCustomCanvasStyle: true,
  exclusive: {
    title: "AI Asset Review",
    onBack({ dispatch }) {
      dispatch(setCurrentAnnotationId(undefined));
      dispatch(changeMode("sheet"));
      return Promise.resolve();
    },
  },
};
